import { bbrCollector } from "./BBR";
import { cvrCollector } from "./CVR";
import { darCollector } from "./DAR";
import { DatafordelerGQL } from "./DatafordelerGQLCollector";
import { dawaCollector } from "./Dawa";
import { dhmCollector } from "./DHM";
import { dllCollector } from "./DLL";
import { ebrCollector } from "./EBR";
import { mat2Collector } from "./Mat2";
import { planDataCollector } from "./PlanData";
import { tinglysningCollector } from "./TL";
import { viaDSCollector } from "./ViaDSCollector";
import { vurdCollector } from "./VURD";
import { WFSCollector } from "./WFSCollector";

/** Collector for External ressources */
export class DataCollector {
   /**
    * Docservice Endpoint (Viamap)
    */
   static ViaDS = viaDSCollector;

   /** 
    * BBR Endpoint (Datafordeler)
    * Bygnings- og Boligregisteret
    */
   static BBR = bbrCollector;

   /**
    * EBR Endpoint (Datafordeler)
    * Ejendomsbeliggenhedregisteret
    */
   static EBR = ebrCollector;

   /** 
    * Mat2 Endpoint (Datafordeler)
    * Matrikel 2
    */
   static MAT2 = mat2Collector;

   /** 
    * DAWA Endpoint (Dataforsyningen) 
    * Danmarks Adressers Web API
    */
   static DAWA = dawaCollector;

   /** 
    * DLL Endpoint (Viamap / Mixed) 
    * De Ledende Landinspektører
    */
   static DLL = dllCollector;

   /**
    * TL Endpoint (Viamap / Molbak)
    * Tinglysning proxy DLL
    */
   static TL = tinglysningCollector;

   /** 
    * DAR Endpoint (Datafordeler)
    * Danmarks Adressers Register
    */
   static DAR = darCollector;

   /**
    * CVR Endpoint (Datafordeler)
    * Det Centrale Virksomhedsregister
    * (DLL Proxy)
    */
   static CVR = cvrCollector;

   /**
    * VURD Endpoint (Datafordeler)
    * Ejendomsvurdering
    * @deprecated USE QGL_VURD INSTEAD (Wait for support at Datafordeler)
    */
   static VURD = vurdCollector;

   /** 
    * DHM Endpoint (Datafordeler)
    * Digital Højdemodel
    */
   static DHM = dhmCollector;

   /**
    * PlanData Endpoint (PlanData)
    * WFS Service for PlanData
    */
   static PlanData = planDataCollector;

   /** 
    * WFS collector with different endpoints (Matriklen2, GeoDanmark etc..)
    */
   static WFS = WFSCollector

   /**
    * Datafordeler GraphQL Endpoint
    */
   static DF_GQL = DatafordelerGQL;

}

/** Collector for External ressources */
export const DC = DataCollector;


/** Definition of data to collect and their dependencies */
const DataToCollect = {
   ESearchEjerlejlighed: { dependency: "Mat2Ejerlejlighed" },
   // Mat2: { identDependency: "latLng" }, //Switch to BFEnr
   // Mat2Ejerlejlighed: { identDependency: "BFEnr" },
   SFEGeom: { identDependency: "BFEnr" },
   // BBRRel: { identDependency: "BFEnr" },
   // ViamapTingBog: { identDependency: "BFEnr" },
   // ViamapEjendomData: { identDependency: "Matnr" }, //Switch to BFEnr
   // Ejerlav: { identDependency: "Matnr" },
   // ViamapHandelsOplysning: { identDependency: "BFEnr" },
   // EBRBFE: { identDependency: "BFEnr" },
   // BBRGrund: { identDependency: "BFEnr" },
   // BBRSFE: { identDependency: "BFEnr" },
   // Vurd: { identDependency: "BFEnr" },
   // PlanDataLokalPlanGeom: { dependency: "SFEGeom" },
   // PlanDataDePlområde: { identDependency: "latLng" }, //SFE_geom
   // PlanDataLokalPlan: { identDependency: "latLng" }, //SFE_geom
   // PlanDataKommunePlan: { identDependency: "latLng" }, //SFE_geom
   // PlanDataKommunePlanForslag: { identDependency: "latLng" }, //SFE_geom
   // PlanDataLokalPlanAflyst: { identDependency: "latLng" }, //SFE_geom
   // PlanDataLokalPlanForslag: { identDependency: "latLng" }, //SFE_geom
   // DHM_Overflade: { identDependency: "latLng" }, //SFE_centroid
   // Marker: { dependency: "SFEGeom" },
   // DHM_Terraen: { identDependency: "latLng" }, //SFE_centroid
   // ViamapEjendomStats: { dependency: ["Mat2", "EBRBFE"] },
   // BBRByg: { dependency: "BBRGrund" },
   // DARAdgang: { dependency: "BBRByg" },
   // DARAdresserEjendom: { dependency: "BBRBFEEnhed" },
   // DARAdresser: { dependency: "DARAdgang" },
   // BBRGrundTeknik: { dependency: "BBRGrund" },
   // BBRBygTeknik: { dependency: "BBRByg" },
   // BBRBFETeknik: { identDependency: "BFEnr" },
   // BBREnhed: { dependency: "BBRByg" },
   // BBREnhedTeknik: { dependency: "BBREnhed" },
   // PEnheder: { dependency: ["Mat2", "BBRSFE"] },
   // MatEjerlejlighed: { identDependency: "BFEnr" },
   // BBRBFEEnhed: { identDependency: "BFEnr" },
   // BBRBFEBygning: { identDependency: "BFEnr" },
   // ViamapEjerskab: { identDependency: "BFEnr" }
}